var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.896 0L7 5.82 1.104 0 0 1.089 7 8l7-6.911z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml,%3csvg width='14px' height='8px' viewBox='0 0 14 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='3' transform='translate(-343.000000, -81.000000)' fill='currentColor'%3e %3cpolygon id='drop' points='355.895556 81 350 86.8195777 344.104444 81 343 82.0886756 350 89 357 82.0886756'%3e%3c/polygon%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgArrow as ReactComponent };